import { Component } from '@angular/core'
import { AutomationEventTypes, AutomationTypes } from '@tokeet-frontend/automations'
import { FormBuilder } from '@angular/forms'
import { on, Store } from '@ngrx/store'
import { AutomationWizardPanelBaseComponent } from '@tv3/containers/automations/automations-wizard/automation-wizard-panel.component'
import { userInventoryNotificationMessages, guestInventoryNotificationMessages } from './messages'
import * as moment from 'moment'
import { AuthService } from '@tv3/services/auth.service'
import { categories, CreateIncidentPayload, IncidentSeverity, IncidentStatus } from '@tokeet-frontend/incident'
import { Actions } from '@ngrx/effects'

@Component({
  selector: 'app-inventory-automation-wizard',
  templateUrl: './inventory-automation-wizard.component.html',
  styleUrls: ['./inventory-automation-wizard.component.scss'],
})
export class InventoryAutomationWizardComponent extends AutomationWizardPanelBaseComponent {
  type = AutomationTypes.Inventory

  guestNotificationMessages = guestInventoryNotificationMessages
  userNotificationMessages = userInventoryNotificationMessages

  categories = categories

  taskForFurtherInspection = {
    name: $localize`An Inventory item was created`,
    user_ids: [this.auth.user.id],
    notes: $localize`An Inventory item was created, please inspect it further and take appropriate action.`,
    timezone: moment.tz.guess(),
  }

  taskForRepair = {
    name: $localize`An Inventory item was created`,
    user_ids: [this.auth.user.id],
    notes: $localize`An Inventory item was created, please assess the damage and take appropriate actions to repair or replace the item.`,
    timezone: moment.tz.guess(),
  }

  taskForDispose = {
    name: $localize`An Inventory item was created`,
    user_ids: [this.auth.user.id],
    notes: $localize`An Inventory item was created, please review the item's status and determine the next steps, such as replacement or disposal.`,
    timezone: moment.tz.guess(),
  }

  taskForAutoReplenish = {
    name: $localize`An Inventory item has reached its minimum quantity`,
    user_ids: [this.auth.user.id],
    notes: $localize`An Inventory item has reached its minimum quantity, please inspect it further and take appropriate action.`,
    timezone: moment.tz.guess(),
  }

  damagedIncident: CreateIncidentPayload = {
    title: $localize`Inventory Damaged`,
    description: $localize`Please assess the damage and take appropriate actions to repair or replace the item.`,
    reporter_id: this.auth.user.id,
    categories: ['Supplies'],
    status: IncidentStatus.Open,
    severity: IncidentSeverity.High,
  }

  inoperableIncident: CreateIncidentPayload = {
    title: $localize`Inventory Inoperable`,
    description: $localize`Please review the item's status and determine the next steps, such as replacement or disposal.`,
    reporter_id: this.auth.user.id,
    categories: ['Supplies'],
    status: IncidentStatus.Open,
    severity: IncidentSeverity.High,
  }

  constructor(
    private auth: AuthService,
    protected fb: FormBuilder,
    protected actions: Actions,
    protected store: Store<any>
  ) {
    super(actions, store, fb)
    this.form.addControl('categories', this.fb.control([]))
    this.form.patchValue({ event: AutomationEventTypes.InventoryCreated })
  }

  protected readonly on = on
}
